module.exports = __webpack_public_path__ + "media/images/front/sp/dummy/sample-sp-738eb7f91e195f92ef5a9e41568f4868.png";